import {
    GamingCuracaoLogo,
    GamingLabLogo,
    // SaLoadingLogo,
    SaLoadingOverlayLogo,
} from '@/components/images';
import { useProgress } from '@/hooks/useProgress';
import { RwdTypography } from '@/modules/rwdGame/components/RwdTypography';
import Grid from '@mui/material/Grid';
import { NetState } from '../lobby/components/NetState';
import './index.scss';
// import './logo.scss';

export const LoadingProgressOverlay = () => (
    <div className="progress loading overlay">
        <SaLoadingOverlayLogo />
    </div>
);

export const LoadingProgress = () => {
    return (
        <Grid
            container
            width="100%"
            height="100%"
            justifyContent={'center'}
            className="self-align-center"
        >
            <div className="progress loading"></div>
            <CertLogoGroup />
            <VersionLabel />
        </Grid>
    );
};
const VersionLabel = () => {
    const { loadingCount, resultCount } = useProgress();
    return (
        <Grid container justifyContent={'center'} gap={'3px'}>
            <NetState color={'white'} />
            <RwdTypography stepIndex={0} landscapeStepIndex={3} color={'white'}>
                ({loadingCount}.{resultCount})
            </RwdTypography>
        </Grid>
    );
};

const CertLogoGroup = () => (
    <Grid container justifyContent={'space-evenly'} className="cert-logo">
        <Grid item>
            <GamingCuracaoLogo className="gaming-logo" />
        </Grid>
        <Grid item>
            <GamingLabLogo className="gaming-logo" />
        </Grid>
    </Grid>
);
